/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Describes whether an entity is available or archived.
 *
 *  - STORAGE_STATE_UNSPECIFIED: Default state. This state in not used
 *  - AVAILABLE: Entity is available.
 *  - ARCHIVED: Entity is archived.
 * @export
 */
export const V2beta1ExperimentStorageState = {
  STORAGE_STATE_UNSPECIFIED: 'STORAGE_STATE_UNSPECIFIED',
  AVAILABLE: 'AVAILABLE',
  ARCHIVED: 'ARCHIVED',
} as const;
export type V2beta1ExperimentStorageState =
  (typeof V2beta1ExperimentStorageState)[keyof typeof V2beta1ExperimentStorageState];

export function instanceOfV2beta1ExperimentStorageState(value: any): boolean {
  for (const key in V2beta1ExperimentStorageState) {
    if (Object.prototype.hasOwnProperty.call(V2beta1ExperimentStorageState, key)) {
      if (
        V2beta1ExperimentStorageState[key as keyof typeof V2beta1ExperimentStorageState] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V2beta1ExperimentStorageStateFromJSON(json: any): V2beta1ExperimentStorageState {
  return V2beta1ExperimentStorageStateFromJSONTyped(json, false);
}

export function V2beta1ExperimentStorageStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ExperimentStorageState {
  return json as V2beta1ExperimentStorageState;
}

export function V2beta1ExperimentStorageStateToJSON(
  value?: V2beta1ExperimentStorageState | null,
): any {
  return value as any;
}

export function V2beta1ExperimentStorageStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V2beta1ExperimentStorageState {
  return value as V2beta1ExperimentStorageState;
}
